import { MODE_META, normalizeMode } from "../lib/modes";

// Small pill showing which coding track (Junior Blocks / Blocks / Python) a drill or question belongs to.
export function TrackBadge({ mode, showPython = false, className = "", testId }) {
  const m = normalizeMode(mode);
  if (m === "python" && !showPython) return null;
  const meta = MODE_META[m];
  const Icon = meta.icon;
  const colors = m === "python" ? "border-border bg-muted/40 text-muted-foreground" : meta.badge;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium leading-none ${colors} ${className}`}
      data-testid={testId || `track-badge-${m}`}
    >
      <Icon className="w-3 h-3" /> {meta.label}
    </span>
  );
}
